<template>
  <div>
    <el-row class="bgW">
      <el-col :span="22">
        <!-- 检索条件 -->
        <el-form class="search" :inline="true" label-suffix="：" size="mini" :model="search">
          <el-form-item label="优惠券类型">
            <el-select v-model="search.type" placeholder="请选优惠券类型" class="w180" clearable>
              <el-option
                v-for="item in options.type"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="2">
        <el-button type="primary" icon="el-icon-search" size="mini" @click="getList('search')">搜索</el-button>
      </el-col>
    </el-row>
    <!-- 列表 -->
    <div class="accountCon" v-loading="clientLoading" element-loading-text="拼命加载中">
      <div v-if="list.length !== 0">
        <div style="display: grid; grid-template-columns: repeat(auto-fill, 300px); column-gap: 45px; row-gap: 20px; padding: 20px 0;">
          <el-card v-for="item in list" :key="item.id" class="card">
            <el-row style="border-bottom: 1px dashed #33bea7; margin-bottom: 5px; padding-bottom: 5px;">
              <el-col :span="20" style="font-size: 17px; font-weight: 600;">{{ item.name }}</el-col>
              <el-col :span="4" style="text-align: right;">
                <span v-if="item.type == 4 && item.staus == 0 && oldId == clienId" class="theme" @click="tapBtn(item)"><b>兑 换</b></span>
                <span v-if="item.staus !=0" style="color: #8c8c8c;">{{item.staus == 1 ? '已使用' : item.staus == 2 ? '已过期' : '未开始'}}</span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">类型：</el-col>
              <el-col :span="13">
                {{ item.type == 1 ? '满减券' : item.type == 3 ? '满赠券' : '兑换券' }}
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">面值：</el-col>
              <el-col :span="13">
                <b style="color: #33bea7;">¥{{ item.denomination }}</b>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">使用门槛(元)：</el-col>
              <el-col :span="13">
                <b style="color: #33bea7">¥{{ item.use_threshold }}</b>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">优惠券状态：</el-col>
              <el-col :span="13">
                <!-- 状态文本添加动态类名 -->
                <span 
                  :class="{
                    'status-unused': item.staus == 0,
                    'status-used': item.staus == 1 || item.staus == 2 || item.staus == 3,
                  }"
                >
                  {{ item.staus == 0 ? '未使用' : item.staus == 1 ? '已使用' : item.staus == 2 ? '已过期' : '未开始' }}
                </span>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="6">有效期：</el-col>
              <el-col :span="18">
                {{ item.start_time.split(' ')[0] }} 至 {{ item.end_time.split(' ')[0] }}
              </el-col>
            </el-row>
            <el-row>
              <el-col>归属门店：{{ detail.shop_name || '无' }}</el-col>
            </el-row>
          </el-card>
        </div>
      </div>
      <el-empty v-else description="暂无数据" class="mr50 mt50"></el-empty>
    </div>
  </div>
</template>

<script>
import { getCouponProvide } from '@/api/client';

class Search {
  type = "";
}

class Options {
  type = [
    { id: 1, name: "满减券" },
    { id: 3, name: "满赠券" },
    { id: 4, name: "兑换券" }
  ];
}

export default {
  name: 'CardList',
  props: {
    clienId: {
      type: String,
      default: ""
    },
    detail: {
      type: Object,
      default() {
        return {};
      }
    },
  },
  data() {
    return {
      clientLoading: true,
      search: new Search(), // 检索条件
      options: new Options(), // 选项
      list: [], // 数据展示
      oldId: ""
    }
  },

  activated() {},
  mounted() {
    this.getList()
    if(this.clienId){
      this.oldId = this.$route.query.id.toString()
    }

  },
  methods: {
    // 获取列表
    getList() {
      getCouponProvide({ ...this.search, customer_id: this.clienId }).then(res => {
        this.list = res.data || [];
        this.clientLoading = false;
      }).catch(() => {
        this.clientLoading = false;
        this.list = [];
      })
    },
    tapBtn(row) {
      const query = { clienId: this.clienId, detail: this.detail, yhj_id: row.id };
      this.$router.push({ name: "兑换订单", query });
    },
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding: 30px 0 50px;
}

// 卡片基础样式优化
::v-deep .el-card {
  border-radius: 6px;
  border: 1px solid #f0f0f0;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    border-color: #e5e5e5;
  }
}

::v-deep .el-card__body {
  padding: 15px 20px !important;
  line-height: 28px;
}

// 状态样式 - 核心区分样式
.status-unused {
  color: #33bea7; /* 品牌主色 - 可用状态 */
  background: rgba(51, 190, 167, 0.1);
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid #33bea7;
  font-size: 12px;
  font-weight: 500;
}

.status-used {
  color: #8c8c8c; /* 中性灰 - 已使用状态 */
  background: rgba(140, 140, 140, 0.1);
  padding: 2px 8px;
  border-radius: 4px;
  border: 1px solid #d9d9d9;
  font-size: 12px;
  font-weight: 500;
}

// 兑换按钮样式
.theme {
  color: #33bea7;
  cursor: pointer;
  font-size: 14px;
  transition: color 0.2s;

  &:hover {
    color: #28a085;
    text-decoration: underline;
  }
}

// 搜索区域样式补充
.bgW {
  padding: 20px;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
}

.w180 {
  width: 180px;
}

.accountCon {
  padding: 0 20px;
  background: #fff;
  min-height: calc(100vh - 150px);
}

.mt50 {
  margin-top: 50px;
}

.mr50 {
  margin-right: 50px;
}
</style>